/*@ngInject*/
const PoliciesSummaryController = function($scope, $stateParams) {
    $scope.isGridFilterVisible = _.isNil($stateParams.policyId);
};

angular.module('gw-um-submission')
    .controller('policiesSummaryController', PoliciesSummaryController);
